import { render } from "./OrarioGiornaliero.vue?vue&type=template&id=1e660c33"
import script from "./OrarioGiornaliero.vue?vue&type=script&lang=js"
export * from "./OrarioGiornaliero.vue?vue&type=script&lang=js"

import "./OrarioGiornaliero.vue?vue&type=style&index=0&id=1e660c33&lang=css"

import exportComponent from "C:\\Users\\fr201\\Informatique\\annuario\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__